<script setup>
import { computed, getCurrentInstance } from 'vue';
import UserAvatar from './UserAvatar.vue';

const props = defineProps({
    tableName: String,
    itemId: Number,
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

/**
 * Retrieves the internal Component ID based on the table name.
 */
const componentId = computed(() => {
    return store.state.components.componentIds[props.tableName];
});

/**
 * Resolves the user ID of whoever is currently 'tracking' (viewing/editing)
 * this specific record.
 * * Logic: It looks into the userTracking state for a key matching "compID-itemID".
 */
const activeUserId = computed(() => {
    if (!componentId.value || !props.itemId) return null;

    const trackingData = store.state.userTracking.data;
    const trackingKey = `${componentId.value}-${props.itemId}`;

    return trackingData[trackingKey] || null;
});
</script>

<template>
    <UserAvatar
        v-if="activeUserId"
        :user-id="activeUserId"
        :tooltip-placement="'right'"
        :is-small="true"
        class="user-tracking-avatar"
    />
</template>

<style scoped>
/* Table View Positioning */
.table-view .user-tracking-avatar {
    position: absolute;
    right: 5px;
}

/* List view Positioning */
.list-view .user-tracking-avatar {
    position: absolute;
    left: -10px;
    top: 10px;
}

/* Sidebar/Nav Positioning */
.themes-editor-nav-link .user-tracking-avatar {
    margin-left: -10px;
}
</style>